// extracted by mini-css-extract-plugin
module.exports = {"attachments":"_28CPw_UAGT5JlEaR364aJ5","text":"_3QhrABmdEeL7PnPB4TH7Rl","message-body":"_1h_g64NAW2eELPI_COi2FN"};